<!-- {{ cli | json}} -->
<div (mouseenter)="this.dropdown = true" (mouseleave)="this.dropdown = false" (click)="this.dropdown = !this.dropdown">

  {{ cli[identificacaoCliente] }}
  <div *ngIf="dropdown"
    style="
      background-color: #424242;
      color: whitesmoke;
      border-radius: 0%;
      display: flex;
      flex-direction: row;
      text-align: justify;
      width: max-content;
      z-index: 99999;
      transform: translateX(-25%); 
      padding: 4px;
      position: absolute;
      box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px; "
    >
    <div>
      {{ hoverDoc(cli) }}<br />
      {{ hoverName(cli) }}
    </div>
  </div>
</div>